export default __webpack_public_path__ + "d628386c7ace8f7b030b524ca4ed3aef.svg";